<template>
  <!-- App.vue -->
  <v-app>
    <!--v-app-bar app dense>
      <app-topbar></app-topbar>
    </v-app-bar>
    <v-navigation-drawer app permanent expand-on-hover v-show="!show">

      <app-sidebar class="sidebar"></app-sidebar>
    </v-navigation-drawer-->

    <!-- Sizes your content based upon application components -->
    <v-container>
      <v-card
        ><v-card-title> {{ title }}</v-card-title
        ><v-card-text>
          <h5>แบ่งตามร้านค้า</h5>
          <div id="chart">
            <apex-chart
              type="bar"
              height="350"
              :options="chartOptions"
              :series="series"
              v-if="loaded"
            ></apex-chart>
          </div>
        </v-card-text>
        <v-card-text>
          <v-row>
            <v-col>
              <h5>แบ่งตามหมวดหมู่</h5>
              <apex-chart
                height="380"
                type="pie"
                :options="chartPieOptions"
                :series="seriesPieCategory"
                v-if="loaded"
              ></apex-chart>
            </v-col>

            <v-col> </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-data-table :headers="headers" :items="data">
            <template v-slot:item.value="{ item }">
              {{ item.value }}</template
            ></v-data-table
          ></v-card-text
        >
      </v-card>
    </v-container>
  </v-app>
</template>
<script>
//import VueCharts from "vue-chartjs";
//import { Bar } from "vue-chartjs";
import axios from "axios";
//import AppSideBar from "../menu/sideBarMenu";
//import AppTopBar from "../menu/topBarMenu";
import VueApexCharts from "vue-apexcharts";
//import { VueFrappe } from "vue2-frappe";
//import "zingchart/es6";
// eslint-disable-next-line no-unused-vars
//import zingchartVue from "zingchart-vue";

//import { thMonth } from "../../../library/config";
// eslint-disable-next-line no-unused-vars
import { numberFormat } from "../../../library/functions";

export default {
  components: {
    /*
"app-sidebar": AppSideBar,
    "app-topbar": AppTopBar,
*/
    "apex-chart": VueApexCharts,
    //"vue-frappe": VueFrappe,
    //"zing-chart": zingchartVue,
  },
  //extends: Bar,
  data() {
    return {
      start: "",
      end: "",
      start_date: new Date(new Date().setDate(new Date().getDate() - 30))
        .toISOString()
        .slice(0, 10), //new Date().toISOString().slice(0,10),//.replace(/-/g,""),
      end_date: new Date().toISOString().slice(0, 10), //.replace(/-/g,""),
      headers: [
        { text: "หมวดหมู่", value: "categoryName" },
        { text: "sku", value: "sku" },
        { text: "ร้านค้า", value: "name" },
        { text: "จำนวนสมาชิก", value: "cntMember" },
        { text: "มูลค่า (บาท)", value: "value" },
        { text: "รายการสินค้า", value: "cntSale" },
        { text: "คะแนน", value: "point" },
      ],
      loaded: false,
      data: [],
      // series: [],
      title: "รายการจำนวนบิลของแต่ละร้านค้าที่ลูกค้านำมาแลกพอยท์",
      pointData: [],

      series: [
        {
          name: "มูลค่า (บาท)",
          data: [],
        },
        {
          name: "คะแนน",
          data: [],
        },
      ],

      seriesPieCategory: [
        // {
        //   name: "มูลค่า (บาท)",
        //   data: [],
        // },
        // // {
        // //   name: "คะแนน",
        // //   data: [],
        // // },
      ],

      chartPieOptions: {
        chart: {
          width: 380,
          type: "pie",
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true | '<img src="/static/icons/reset.png" width="20">',
              customIcons: [],
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return numberFormat(val, 2) + "%";
          },
        },
        labels: [],
        tooltips: {
          z: {
            formatter: function (val) {
              console.log(val);
              return numberFormat(val, 2) + "%";
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },

      chartOptions: {
        // Bar Chart

        chart: {
          type: "bar",
          height: 600,
        },
        plotOptions: {
          bar: {
            colors: {
              ranges: [
                {
                  from: -100,
                  to: -46,
                  color: "#F15B46",
                },
                {
                  from: -45,
                  to: 0,
                  color: "#FEB019",
                },
              ],
            },
            columnWidth: "80%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          title: {
            text: "มูลค่า (บาท) / คะแนน",
          },
          labels: {
            // eslint-disable-next-line no-unused-vars
            formatter: function (y) {
              return numberFormat(y, 2); //y.toFixed(0) + "%";
            },
          },
        },
        xaxis: {
          //type: "datetime",
          categories: [],
          labels: {
            rotate: -90,
          },
        },
      },
    };
  },
  mounted() {
    console.log("mounted");
    //async () => {
    console.log("call point flow");
    const url = process.env.VUE_APP_LOYALTY_API_URI;
    try {
      //
      let payloadBody = {
        createdBy: sessionStorage.getItem("email"),
        updatedBy: sessionStorage.getItem("email"),
        custId: sessionStorage.getItem("custId"),
        start: this.start_date,
        end: this.end_date,
      };
      axios
        .post(
          url + "/v1/report/pointSummaryByProduct",
          payloadBody // need to change
        )
        .then((response) => {
          console.log(response.data);

          if (response.status == 200) {
            this.data = response.data.map((item) => {
              //
              return {
                categoryName: item._id.categoryId.name,
                sku: item._id.sku,
                name: item._id.name,
                value: item.sumAmount,
                point: item.sumPoint,
                cntSale: item.cntSale,
                cntMember: item.cntMember,
              };
            });
            // let earnPoint = response.data.earnPoint.map((item) => {
            //   let formattedId = "";
            //   let ymd = item._id.split("-");
            //   formattedId = ymd[2] + " " + thMonth[parseInt(ymd[1]) - 1] + " " + ymd[0];
            //   return { sum: item.sum, _id: formattedId };
            // }); //
            // let redeemPoint = response.data.redeemPoint.map((item) => {
            //   let formattedId = "";
            //   let ymd = item._id.split("-");
            //   formattedId = ymd[2] + " " + thMonth[parseInt(ymd[1]) - 1] + " " + ymd[0];
            //   return { sum: item.sum, _id: formattedId };
            // }); //
            //console.log(redeemPoint);
            //this.pointData = { redeemPoint: redeemPoint, earnPoint: earnPoint };
            //let tempCategory = "";
            let tempIndex = -1;
            //let valueByCategory = [];

            for (let i = 0; i < this.data.length; i++) {
              console.log(this.data[i].value);
              if (this.chartPieOptions.labels.indexOf(this.data[i].categoryName) == -1) {
                //

                this.chartPieOptions.labels.push(this.data[i].categoryName);
                //tempCategory = this.data[i].categoryName;
                console.log("tempIndex");
                tempIndex++;
                this.seriesPieCategory[tempIndex] =
                  parseFloat(this.seriesPieCategory[tempIndex] || 0) + this.data[i].value;
                console.log(tempIndex);
                console.log(this.seriesPieCategory[tempIndex]);
              } else {
                //tempIndex++;
                console.log("existed Index");
                let _index = this.chartPieOptions.labels.indexOf(
                  this.data[i].categoryName
                );
                console.log(_index);
                this.seriesPieCategory[_index] =
                  parseFloat(this.seriesPieCategory[_index] || 0) + this.data[i].value;
                console.log(this.seriesPieCategory[_index]);
              }
              this.chartOptions.labels;
              this.chartOptions.xaxis.categories.push(this.data[i].name);
              if (this.chartOptions.yaxis.max < this.data[i].value) {
                this.chartOptions.yaxis.max = this.data[i].value;
              }
              if (this.chartOptions.yaxis.min > this.data[i].value) {
                this.chartOptions.yaxis.min = this.data[i].value;
              }

              this.series[0].data.push(this.data[i].value);
              this.series[1].data.push(this.data[i].point);
            }

            console.log(this.seriesPieCategory);
            // */
            // for (let i = 0; i < earnPoint.length; i++) {
            //   //this.chartOptions.xaxis.categories.push(data.earnPoint[i]._id);
            //   this.chartData.scaleX.values.push(response.data.earnPoint[i]._id);

            //   //this.chartData[0].values.push(earnPoint[i].sum);
            //   //this.chartData[1].values.push(redeemPoint[i].sum);
            // }
            console.log(this.chartData);
            this.loaded = true;
          }
        });
      //console.log(_Clients);
      //return _Clients;
    } catch (err) {
      console.log(err);
    }
    //};
  },
};
</script>
<style lang="scss" scoped>
.v-data-table-header {
  thead th {
    background-color: black;
  }
}
</style>
